var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticStyle: { cursor: "pointer" }, on: { click: _vm.goBack } },
      [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Return")))])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { margin: "10px 20px" } },
      [
        _c(
          "el-card",
          { staticStyle: { "padding-bottom": "40px" } },
          [
            _c("div", [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "16px",
                    "font-family": "PingFang SC",
                    "font-weight": "500",
                    "line-height": "51px"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("i18n_Billing_Number")) +
                      "：" +
                      _vm._s(_vm.basicData.billNo)
                  )
                ]
              ),
              _vm._v(" "),
              _c("span", {
                staticStyle: { width: "50px", display: "inline-block" }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "16px",
                    "font-family": "PingFang SC",
                    "font-weight": "500",
                    "line-height": "51px"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("i18n_Payment_amount")) +
                      "：" +
                      _vm._s(_vm.basicData.amount) +
                      " " +
                      _vm._s(_vm.basicData.currency)
                  )
                ]
              ),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _vm.basicData.state == "S"
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-family": "PingFang SC",
                        "font-weight": "500",
                        "line-height": "51px"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("i18n_Payment_Time")) +
                          "：" +
                          _vm._s(_vm.basicData.payTime)
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", {
                staticStyle: { width: "50px", display: "inline-block" }
              }),
              _vm._v(" "),
              _vm.basicData.state == "S"
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-family": "PingFang SC",
                        "font-weight": "500",
                        "line-height": "51px"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("i18n_Payment_Method")) +
                          "：" +
                          _vm._s(
                            _vm.$t(
                              _vm.basicData.payType == "A"
                                ? "i18n_Alipay_payment"
                                : "i18n_WeChat_Pay"
                            )
                          )
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.pageList,
                  "header-cell-style": {
                    background: "#eef1f6",
                    color: "#606266"
                  },
                  border: "",
                  align: "center",
                  "highlight-current-row": ""
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "90",
                    type: "index",
                    label: _vm.$t("i18n_Serial_number")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "nos",
                    label: _vm.$t("i18n_tracking_number")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "feeName",
                    label: _vm.$t("i18n_Fee_Name")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "amount",
                    label: _vm.$t("i18n_Amount_receivable")
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.amount) +
                              "\n            " +
                              _vm._s(scope.row.currency) +
                              "\n          "
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "arapTime",
                    label: _vm.$t("i18n_cost_generated_time")
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("el-pagination", {
                  staticStyle: { "margin-top": "20px", float: "right" },
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { clear: "both" } })
              ],
              1
            ),
            _vm._v(" "),
            _vm.basicData.id
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "20px", float: "right" } },
                  [
                    _vm.basicData.state == "C" || _vm.basicData.state == "I"
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { width: "120px" },
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.toPay(
                                  _vm.id,
                                  "detail",
                                  _vm.totalAmount
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_Go_to_pay")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.basicData.state != "S"
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { width: "200px", color: "#5f4aff" },
                            on: {
                              click: function($event) {
                                _vm.dialogVisible = true
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("i18n_upload_payment_receipt"))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.basicData.state == "C" || _vm.basicData.state == "I"
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { width: "120px" },
                            on: {
                              click: function($event) {
                                return _vm.invalid(_vm.basicData.state)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_Abandoned")))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              "before-close": _vm.handleClose,
              title: _vm.$t("i18n_Image_Upload"),
              visible: _vm.dialogVisible,
              width: "50%"
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible = $event
              }
            }
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    attrs: {
                      "on-preview": _vm.handlePreview,
                      "on-success": _vm.onSuccess,
                      "on-remove": _vm.handleRemove,
                      "before-upload": _vm.beforeUpload,
                      "on-change": _vm.onChange,
                      "file-list": _vm.fileList,
                      action:
                        "https://www.yundaomen.com.cn:8080/arap/uploadTransferVoucher",
                      limit: 6,
                      "on-exceed": _vm.handleExceed,
                      headers: _vm.headers,
                      data: _vm.iniData,
                      "list-type": "picture-card",
                      "auto-upload": false
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "file",
                        fn: function(ref) {
                          var file = ref.file
                          return _c("div", {}, [
                            _c("img", {
                              staticClass: "el-upload-list__item-thumbnail",
                              attrs: { src: file.url, alt: "" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "el-upload-list__item-actions" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-upload-list__item-preview",
                                    on: {
                                      click: function($event) {
                                        return _vm.handlePictureCardPreview(
                                          file
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-zoom-in" })]
                                ),
                                _vm._v(" "),
                                !_vm.disabled
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-delete",
                                        on: {
                                          click: function($event) {
                                            return _vm.handleRemove(file)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        }
                      }
                    ])
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-plus",
                      attrs: { slot: "default" },
                      slot: "default"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-top": "10px" },
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.upLoadPic()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_Confirm_Upload")))]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Up_to_6_JPG")))]),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: { modal: false, visible: _vm.dialogVisible1 },
                    on: {
                      "update:visible": function($event) {
                        _vm.dialogVisible1 = $event
                      }
                    }
                  },
                  [
                    _c("div", { staticStyle: { "text-algin": "center" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            zoom: "50%",
                            position: "absolute",
                            opacity: "0.5",
                            width: "100%",
                            "text-align": "center",
                            "z-index": "1"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.rotate()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_Rotation")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.rotate("big")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_Enlarge")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.rotate("small")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_zoom_out")))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        ref: "imgRef",
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          "max-height": "500px"
                        },
                        attrs: { src: _vm.dialogImageUrl, alt: "" }
                      })
                    ])
                  ]
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-215ffd65", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215ffd65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/billType/PayDetail.vue
// module id = null
// module chunks = 